import { NgModule } from '@angular/core';

import { BecomeACustomerUsageQuestionnaireComponentModule } from './become-a-customer-usage-questionnaire-component.module';

@NgModule({
  imports: [BecomeACustomerUsageQuestionnaireComponentModule],
})
export class BecomeACustomerUsageQuestionnaireModule {}
